export default __webpack_public_path__ + "static/media/spinner.746a4843.gif";